import { render, staticRenderFns } from "./UserSettingsConnections.vue?vue&type=template&id=4efde9fc&"
import script from "./UserSettingsConnections.vue?vue&type=script&lang=js&"
export * from "./UserSettingsConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports